import { defineStore, storeToRefs } from "pinia"
import { computed } from "vue"
import { useInstructionStore } from "@/store/instructions.store"
import { Sale } from "@/models/sale.model"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import { useRelatedObjectsManager } from "@/composables/socket/related-objects-manager"
import type { Instruction } from "@/models/instruction.model"

export const useSaleStore = defineStore("saleStore", () => {
  const instructionStore = useInstructionStore()
  const { instructions } = storeToRefs(instructionStore)

  const sales = computed(() => {
    const sales = []
    for (const instruction of instructions.value) {
      sales.push(...instruction.sales)
    }
    return sales
  })
  const { pushToRelatedObjects, removeFromRelatedObjects } = useRelatedObjectsManager(
    instructions,
    (sale: Sale) => sale.instruction,
    (instruction: Instruction) => instruction.id!,
    (instruction: Instruction) => instruction.sales
  )
  function removeSale(sale: Sale) {
    removeFromRelatedObjects(sale)
  }

  useSocketSynchronizationHandlers(Sale, null, pushToRelatedObjects, removeSale, false)

  return {
    sales,
    pushToRelatedObjects,
    removeFromRelatedObjects: removeSale
  }
})
